/**
 * 결재 양식 본문 공통 표·입력 — 레거시 품의 폼 스타일 값 그대로.
 * 양식별 컬럼·동작은 각 양식 컴포넌트가 조합
 */
export { default as ApprovalClearableInput } from './ApprovalClearableInput';
export { default as ApprovalFormTable } from './ApprovalFormTable';
export { default as ApprovalSectionToggle } from './ApprovalSectionToggle';
export { default as ApprovalTableCurrencySelect } from './ApprovalTableCurrencySelect';
export {
  APPROVAL_TABLE_BORDER,
  ApprovalOutlineInput,
  ApprovalTableAddRowButton,
  ApprovalTableCalculatedCell,
  ApprovalTableCellInput,
  ApprovalTableRow,
  ApprovalTableRowDeleteButton,
  ApprovalTableUnit,
  ApprovalValueBox,
  approvalFormTableStyles,
  approvalOutlineSelectSx,
  approvalSectionToggleStyles,
  approvalTableCellSelectSx,
  approvalValueBoxStyles,
} from './styles';
